import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import { AdsTxtDomainStatus, type AdsTxtDomainsFilter } from './model';

export interface AdsTxtDomainsRouteSearch {
  search?: string;
  statuses?: string;
  page?: number;
  size?: number;
}

const defaultAdsTxtDomainsFilter: AdsTxtDomainsFilter = {
  searchTerm: '',
  statuses: [],
  page: 0,
  size: 10,
};

export function adsTxtDomainsRouteSearchSchema(search: Record<string, unknown>) {
  const searchTerm = optionalTrimmedString(search['search']);
  const statuses = typeof search['statuses'] === 'string' ? search['statuses'] : undefined;
  const page = optionalPositiveInteger(search['page']);
  const size = optionalPositiveInteger(search['size']);
  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(statuses ? { statuses } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
  } satisfies AdsTxtDomainsRouteSearch;
}

export function parseAdsTxtDomainsRouteSearch(
  search: AdsTxtDomainsRouteSearch,
): AdsTxtDomainsFilter {
  const valid = new Set<string>(Object.values(AdsTxtDomainStatus));
  return {
    searchTerm: search.search ?? '',
    statuses:
      search.statuses
        ?.split(',')
        .map((status) => status.trim())
        .filter((status): status is AdsTxtDomainStatus => valid.has(status)) ?? [],
    page: search.page ? search.page - 1 : 0,
    size: search.size ?? defaultAdsTxtDomainsFilter.size,
  };
}

export function serializeAdsTxtDomainsRouteSearch(
  filter: AdsTxtDomainsFilter,
): AdsTxtDomainsRouteSearch {
  return {
    ...(filter.searchTerm.trim() ? { search: filter.searchTerm.trim() } : {}),
    ...(filter.statuses.length ? { statuses: filter.statuses.join(',') } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultAdsTxtDomainsFilter.size ? { size: filter.size } : {}),
  };
}
